/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1173
 */

var r = require(/* 1430 */"../../../../../../253/2588/1461/2585/502/1430")
var i = exports && !exports.nodeType && exports
var o = i && "object" == typeof module && module && !module.nodeType && module
var a = o && o.exports === i && r.process
var s = function () {
  try {
    var e = o && o.require && o.require("util").types
    return e || a && a.binding && a.binding("util")
  } catch (t) {}
}()
module.exports = s
